/**
 * The question currently on screen, so feedback can be attached to it.
 *
 * WHY A MODULE REGISTER AND NOT A PROP. FeedbackButton is mounted in the app
 * shell (AppHeader, DesktopShell), which knows nothing about drills. Threading an
 * item id from every drill up through the shell would touch every route to serve
 * one widget, and the shell would then re-render on every question change.
 *
 * WHAT IT COST TO NOT HAVE THIS. On 2026-09-07 a student wrote "the answer being
 * two also makes sense I don't get why it isn't correct" from a maths drill. The
 * message arrived with item_id null, because the widget never sent one, so
 * identifying the question meant querying their attempt history and matching on
 * timestamps. A dispute about a specific question is the single most valuable
 * report we get, and it was the one arriving without the question attached.
 *
 * Deliberately not React state: nothing renders from it, and a re-render per
 * question purely to inform a button would be a worse trade than a module
 * variable that the widget reads at submit time.
 */

let currentItemId: string | null = null;

/** Call when the visible question changes. Pass null when leaving the screen. */
export function setCurrentItem(id: string | null | undefined): void {
  currentItemId = id ?? null;
}

/** Read at submit time. Never rendered, so a stale value cannot reach the UI. */
export function getCurrentItem(): string | null {
  return currentItemId;
}
